<template>
  <c-panel caption="お支払い方法">
    <template>
      <tr>
        <td>お支払い方法の登録はありません。</td>
      </tr>
    </template>

    <template #actions>
      <c-panel-action
        caption="お支払い方法を追加する"
        :to="{ name: 'my/newcard' }"
      />
    </template>
  </c-panel>
</template>

<script>
import base from '../base'

export default {
  name: 'CEmptyPanel',
  mixins: [
    base
  ]
}
</script>
